var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.598247,
    y: 0.418803,
    width: 29.1624,
    height: 29.1624,
    rx: 2.93162,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.598247,
    y: 0.418803,
    width: 29.1624,
    height: 29.1624,
    rx: 2.93162,
    stroke: "#E5E7EB",
    strokeWidth: 0.837607
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5043 9.55552C13.5043 9.44445 13.5484 9.33792 13.627 9.25938C13.7055 9.18084 13.812 9.13672 13.9231 9.13672C14.0342 9.13672 14.1407 9.18084 14.2193 9.25938C14.2978 9.33792 14.3419 9.44445 14.3419 9.55552V19.8522C14.3419 19.935 14.3174 20.0159 14.2714 20.0847C14.2254 20.1536 14.1601 20.2072 14.0836 20.2389C14.0072 20.2707 13.9231 20.279 13.8419 20.263C13.7607 20.2469 13.6861 20.2072 13.6274 20.1487L9.73425 16.2564C9.69524 16.2175 9.6643 16.1713 9.64319 16.1204C9.62207 16.0695 9.61121 16.015 9.61121 15.9599C9.61121 15.9048 9.62207 15.8502 9.64319 15.7994C9.6643 15.7485 9.69524 15.7023 9.73425 15.6634H9.73592C9.81442 15.5851 9.92075 15.5411 10.0316 15.5411C10.1424 15.5411 10.2488 15.5851 10.3273 15.6634L13.5043 18.8429V9.55552ZM16.0171 10.1477C16.0173 10.065 16.042 9.98422 16.088 9.91552C16.134 9.84682 16.1994 9.79328 16.2758 9.76166C16.3522 9.73004 16.4363 9.72175 16.5174 9.73783C16.5985 9.75391 16.673 9.79365 16.7316 9.85203L20.6248 13.7436C20.6638 13.7825 20.6948 13.8287 20.7159 13.8796C20.737 13.9304 20.7478 13.985 20.7478 14.0401C20.7478 14.0952 20.737 14.1497 20.7159 14.2006C20.6948 14.2515 20.6638 14.2977 20.6248 14.3366H20.6231C20.5446 14.4148 20.4383 14.4588 20.3275 14.4588C20.2166 14.4588 20.1103 14.4148 20.0318 14.3366L16.8547 11.1587V20.4444C16.8547 20.5555 16.8106 20.662 16.7321 20.7406C16.6535 20.8191 16.547 20.8632 16.4359 20.8632C16.3249 20.8632 16.2183 20.8191 16.1398 20.7406C16.0613 20.662 16.0171 20.5555 16.0171 20.4444V10.1477Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIcon);
export default __webpack_public_path__ + "static/media/SortIcon.a29f708dfe1b7350d51fc70eb4f613b9.svg";
export { ForwardRef as ReactComponent };